import axios from "axios";
import { apiEndpoint, apiEndpointFunction } from '@iso/lib/helpers/endpoint';
import { authHeader } from '@iso/lib/helpers/authHeader';

export const licenceService = {
  getList,
  storeOrUpdate,
  getCheckinFormUserLicense,
  destroy,
};

function getList(userId, type){
  return (
    axios
      .get(
        `${apiEndpoint.licences}?user_id=${userId}&type=${type}`,
        {
          headers: authHeader(),
        }
      ).then(res => {
        if(res && res.status === 200 && res.data.code === '0000'){
          return res.data;
        }
      })
  );
}

function getCheckinFormUserLicense(form_id, userId, type){
  return (
    axios
      .get(
        `${apiEndpoint.licences}/get-checkin-form-user-license?form_id=${form_id}&user_id=${userId}&type=${type}`,
        {
          headers: authHeader(),
        }
      ).then(res => {
        if(res && res.status === 200 && res.data.code === '0000'){
          return res.data;
        }
      })
  );
}

function storeOrUpdate(data, id = null){
  return (id ? (
    axios
      .put(
        apiEndpointFunction.licences(id),
        data,
        {
          headers: authHeader(),
        }
      )
  ) : (
    axios
      .post(
        apiEndpoint.licences,
        data,
        {
          headers: authHeader()
        }
      )
  )).then(res => {
    if(res && res.status === 200){
      return res.data;
    }
    return {};
  });
}

function destroy ( id )
{
  return (
    axios
      .delete(
        apiEndpointFunction.licences(id),
        {
          headers: authHeader()
        }
      ).then( res =>   
      {
        if ( res && res.status===200 )
        {
          return res.data;
        }
      } )
  );
}